// Generated by CoffeeScript 2.7.0
import Admin__UserProfile__SchemasController from './schemas.js';

Skylark.App.Controllers.register({Admin__UserProfile__SchemasController});
